import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import FooterTabLinks from "./FooterTabLinks";

import backgroundImage from "./assets/images/background.jpg";
import "./styles/style.scss";

class Layout extends PureComponent {
  static propTypes = {
    database: PropTypes.object.isRequired
  };

  render() {
    return (
      <div className="page-wrapper">
        <div className="app-container">
          <div className="content">
            <div className="foreground">{this.props.children}</div>
            <div
              className="background"
              style={{ backgroundImage: `url(${backgroundImage})` }}
            />
          </div>
          <footer>
            <FooterTabLinks />
          </footer>
        </div>
      </div>
    );
  }
}

export default Layout;
